import { Drawer } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import SidebarNav from './components/SidebarNav/SidebarNav';
import { useStyles } from './styles';

const Sidebar = (props) => {
  const {
    open, variant, disableMenu,
  } = props;
  const classes = useStyles();

  return (
    <Drawer
      anchor="left"
      variant={variant}
      open={open}
      className={clsx(classes.drawer, {
        [classes.drawerOpen]: open,
        [classes.drawerClose]: !open,
      })}
      classes={{
        paper: clsx(classes.paper, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        }),
      }}
    >
      <SidebarNav
        disableMenu={disableMenu}
      />
    </Drawer>
  );
};

Sidebar.propTypes = {
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired,
  disableMenu: PropTypes.bool.isRequired,
};

export default Sidebar;
